export interface FreeTrialDTO {
    submit_id_c: string;
    password: string;
    excuse_c: string;
    email: string;
    first_name: string;
    last_name: string;
    mobile_number_c: string;
    account_name: string;
    greeting_c: string;
    salutation: string;
    website: string;
    isVoiceBotFreeTrial: boolean;
}

export class FreeTrialAccount {
    public submit_id_c: string | undefined;
    public password: string | undefined;
    public excuse_c: string | undefined;
    email: string;
    first_name: string;
    last_name: string;
    mobile_number_c: string;
    greeting_c = 'Welcome how I can help you?'; // TODO
    captcha_solution: string | undefined;
    website: string;
    account_name = 'Voicebot_Test';
    isVoiceBotFreeTrial = true;
    
    constructor(acc: string, defaultDomain: string, c_prefix: string, number: string, website: string, captcha_solution: string) {
        this.mobile_number_c = `${c_prefix}${number}`;
        this.first_name = acc.concat(defaultDomain);
        this.last_name = acc.concat('l');
        this.captcha_solution = captcha_solution;
        this.email = acc.concat('f');
        this.website = website;
    }
    
    public get freeTrialDTO(): FreeTrialDTO {
        return {
            submit_id_c: !!this.submit_id_c ? this.submit_id_c : '',
            password: !!this.password ? this.password : '',
            excuse_c: !!this.excuse_c ? this.excuse_c : '',
            email: this.email,
            first_name: this.first_name,
            last_name: this.last_name,
            mobile_number_c: this.mobile_number_c,
            account_name: this.account_name,
            salutation: 'Herr',
            greeting_c: this.greeting_c,
            website: this.website,
            isVoiceBotFreeTrial: this.isVoiceBotFreeTrial
        };
    }
}

export type FreeTrialResponse = {
    result: 'success' | 'error';
    data: {
        verification_hash?: string;
        number?: string;
        displayNumber?: string;
        customerType?: string;
    };
    message: string;
};


